module.exports = __webpack_public_path__ + "static/img/webinar_lymphomap_jascap_thumb.905ded09.jpg";